import type { AppContext } from '@/main';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard')<AppContext>({
  component: Outlet,
  loader: () => ({
    crumb: 'Dashboard',
  }),
});
